/**
 * Bilingual text for the estimate pages
 */

const copy = {
  en: {
    // Start
    startTitle: 'New estimate',
    startSubtitle: 'Choose how much detail you want to give. You can refine a quick estimate later.',
    quickTitle: 'Quick estimate',
    quickDesc: 'House type, size and finishing. We fill in typical rooms and structure.',
    quickTime: '4 questions · about 1 minute',
    detailedTitle: 'Detailed estimate',
    detailedDesc: 'Choose walls, foundation, roof, ceiling and count your rooms, doors and windows.',
    detailedTime: '3 sections · about 3 minutes',
    bestFor: 'Best for',
    quickBestFor: 'Checking if a house fits your budget',
    detailedBestFor: 'A full material list to compare with contractor quotes',
    // Basics
    houseType: 'House type',
    builtUpArea: 'Built-up area',
    builtUpAreaHint: 'Total floor area of all storeys, as in your plan or listing',
    areaPlaceholder: 'e.g. 1,200',
    areaTooSmall: 'Enter at least 300 sq ft',
    areaPresets: 'Common sizes',
    floors: 'Storeys',
    storey: 'storey',
    storeys: 'storeys',
    finishing: 'Finishing level',
    perSqft: '/sq ft',
    recommended: 'Most common',
    projectName: 'Project name (optional)',
    projectNamePlaceholder: 'e.g. Rumah Kampung Ayah',
    sqft: 'sq ft',
    // Detailed
    sectionHouse: 'Your house',
    sectionStructure: 'Structure',
    sectionStructureHint: 'Typical choices are pre-selected. Change them if you know your plan.',
    sectionRooms: 'Rooms, doors & windows',
    sectionRoomsHint: 'Pre-filled from your house size. Adjust to match your plan.',
    wallHeight: 'Wall height per storey',
    wallType: 'Walls',
    brick45: 'Half brick (4.5")',
    brick9: 'Full brick (9")',
    block: 'Concrete block',
    foundationType: 'Foundation',
    strip: 'Strip footing',
    pad: 'Pad footing',
    raft: 'Raft',
    roofType: 'Roof',
    metal: 'Metal deck',
    tiles: 'Roof tiles',
    concrete: 'Concrete flat roof',
    ceilingType: 'Ceiling',
    gypsum: 'Gypsum board',
    pvc: 'PVC panel',
    plaster: 'Plastered',
    bedrooms: 'Bedrooms',
    bathrooms: 'Bathrooms',
    kitchen: 'Kitchen',
    livingArea: 'Living / dining',
    store: 'Store / utility',
    mainDoors: 'Main doors',
    roomDoors: 'Room doors',
    windows: 'Windows',
    bathroomDoorsNote: 'Bathroom doors are counted automatically',
    // Actions
    calculate: 'See my estimate',
    calculateCompare: 'Compare with current estimate',
    comparing: 'Comparing with',
    cancelCompare: 'Cancel comparison',
    back: 'Back',
    // Result
    resultTitle: 'Your estimate',
    estimatedCost: 'Estimated construction cost',
    likely: 'Most likely',
    range: 'Range',
    costPerSqft: 'Cost per sq ft',
    breakdown: 'Where the money goes',
    breakdownHint: 'Typical share of the budget for each part of the build',
    materials: 'Materials you will need',
    materialsHint: 'Quantities include normal wastage. Ranges are ±12%.',
    materialsLegacy: 'Saved with an older version — re-calculate for the full material list.',
    tabSummary: 'Summary',
    tabMaterials: 'Materials',
    tabAssumptions: 'Assumptions',
    included: 'Based on',
    notIncluded: 'Not included',
    notIncludedShort: 'land, earthworks, piling, fencing, built-in furniture, professional & permit fees.',
    disclaimerShort: 'Planning estimate only — not a quotation. Get quotes from licensed contractors.',
    save: 'Save',
    saved: 'Saved',
    exportPdf: 'PDF report',
    compare: 'Compare',
    refine: 'Refine with more detail',
    newEstimate: 'New estimate',
    edit: 'Edit inputs',
    quickBadge: 'Quick estimate',
    detailedBadge: 'Detailed estimate',
    savedToast: 'Saved to Projects',
    noResult: 'No estimate yet',
    noResultDesc: 'Start a quick estimate to see the cost of your house.',
    startQuick: 'Start quick estimate',
    // Compare
    compareTitle: 'Comparison',
    current: 'Current',
    scenario: 'New scenario',
    difference: 'Difference',
    total: 'Total (most likely)',
    removeCompare: 'Clear comparison',
    // Assumptions for quick
    quickAssumed: 'Assumed for a quick estimate',
    rooms: 'rooms',
  },
  my: {
    startTitle: 'Anggaran baru',
    startSubtitle: 'Pilih berapa banyak butiran yang anda mahu beri. Anda boleh perincikan anggaran pantas kemudian.',
    quickTitle: 'Anggaran pantas',
    quickDesc: 'Jenis rumah, saiz dan kemasan. Kami isi bilik dan struktur yang biasa.',
    quickTime: '4 soalan · kira-kira 1 minit',
    detailedTitle: 'Anggaran terperinci',
    detailedDesc: 'Pilih dinding, asas, bumbung, siling dan kira bilik, pintu serta tingkap.',
    detailedTime: '3 bahagian · kira-kira 3 minit',
    bestFor: 'Sesuai untuk',
    quickBestFor: 'Semak sama ada rumah muat dengan bajet anda',
    detailedBestFor: 'Senarai bahan penuh untuk dibandingkan dengan sebut harga kontraktor',
    houseType: 'Jenis rumah',
    builtUpArea: 'Luas binaan',
    builtUpAreaHint: 'Jumlah luas lantai semua tingkat, seperti dalam pelan atau iklan',
    areaPlaceholder: 'cth. 1,200',
    areaTooSmall: 'Masukkan sekurang-kurangnya 300 kaki persegi',
    areaPresets: 'Saiz biasa',
    floors: 'Tingkat',
    storey: 'tingkat',
    storeys: 'tingkat',
    finishing: 'Tahap kemasan',
    perSqft: '/kps',
    recommended: 'Paling biasa',
    projectName: 'Nama projek (pilihan)',
    projectNamePlaceholder: 'cth. Rumah Kampung Ayah',
    sqft: 'kps',
    sectionHouse: 'Rumah anda',
    sectionStructure: 'Struktur',
    sectionStructureHint: 'Pilihan biasa telah dipilih. Tukar jika anda tahu pelan anda.',
    sectionRooms: 'Bilik, pintu & tingkap',
    sectionRoomsHint: 'Diisi mengikut saiz rumah. Laraskan mengikut pelan anda.',
    wallHeight: 'Tinggi dinding setiap tingkat',
    wallType: 'Dinding',
    brick45: 'Separuh bata (4.5")',
    brick9: 'Bata penuh (9")',
    block: 'Blok konkrit',
    foundationType: 'Asas',
    strip: 'Tapak jalur',
    pad: 'Tapak pad',
    raft: 'Rakit',
    roofType: 'Bumbung',
    metal: 'Dek logam',
    tiles: 'Jubin bumbung',
    concrete: 'Bumbung rata konkrit',
    ceilingType: 'Siling',
    gypsum: 'Papan gipsum',
    pvc: 'Panel PVC',
    plaster: 'Diplaster',
    bedrooms: 'Bilik tidur',
    bathrooms: 'Bilik air',
    kitchen: 'Dapur',
    livingArea: 'Ruang tamu / makan',
    store: 'Stor / utiliti',
    mainDoors: 'Pintu utama',
    roomDoors: 'Pintu bilik',
    windows: 'Tingkap',
    bathroomDoorsNote: 'Pintu bilik air dikira secara automatik',
    calculate: 'Lihat anggaran saya',
    calculateCompare: 'Bandingkan dengan anggaran semasa',
    comparing: 'Membandingkan dengan',
    cancelCompare: 'Batal perbandingan',
    back: 'Kembali',
    resultTitle: 'Anggaran anda',
    estimatedCost: 'Anggaran kos pembinaan',
    likely: 'Paling mungkin',
    range: 'Julat',
    costPerSqft: 'Kos sekaki persegi',
    breakdown: 'Ke mana wang digunakan',
    breakdownHint: 'Bahagian bajet yang biasa bagi setiap kerja',
    materials: 'Bahan yang anda perlukan',
    materialsHint: 'Kuantiti termasuk pembaziran biasa. Julat ±12%.',
    materialsLegacy: 'Disimpan dengan versi lama — kira semula untuk senarai bahan penuh.',
    tabSummary: 'Ringkasan',
    tabMaterials: 'Bahan',
    tabAssumptions: 'Andaian',
    included: 'Berdasarkan',
    notIncluded: 'Tidak termasuk',
    notIncludedShort: 'tanah, kerja tanah, cerucuk, pagar, perabot terbina, fi profesional & permit.',
    disclaimerShort: 'Anggaran perancangan sahaja — bukan sebut harga. Dapatkan sebut harga daripada kontraktor berlesen.',
    save: 'Simpan',
    saved: 'Disimpan',
    exportPdf: 'Laporan PDF',
    compare: 'Banding',
    refine: 'Perincikan lagi',
    newEstimate: 'Anggaran baru',
    edit: 'Ubah input',
    quickBadge: 'Anggaran pantas',
    detailedBadge: 'Anggaran terperinci',
    savedToast: 'Disimpan ke Projek',
    noResult: 'Tiada anggaran lagi',
    noResultDesc: 'Mulakan anggaran pantas untuk melihat kos rumah anda.',
    startQuick: 'Mula anggaran pantas',
    compareTitle: 'Perbandingan',
    current: 'Semasa',
    scenario: 'Senario baru',
    difference: 'Beza',
    total: 'Jumlah (paling mungkin)',
    removeCompare: 'Padam perbandingan',
    quickAssumed: 'Andaian untuk anggaran pantas',
    rooms: 'bilik',
  },
};

export const getEstimateCopy = (language) => copy[language] || copy.en;

export default copy;
